import Vue from 'vue';
import Vuex from 'vuex';
import {LaravelApiModule} from 'clockvine-vue';


Vue.use(Vuex);

let companies = new LaravelApiModule('/order/api/companies');
let companyMembers = new LaravelApiModule('/order/api/companies/{company}/members');
let dealerZones = new LaravelApiModule('/order/api/dealer-zones');
let holidays = new LaravelApiModule('/order/api/holidays');
let orders = new LaravelApiModule('/order/api/orders');
let orderList = new LaravelApiModule('/order/api/orders?status={status}&page={page}&order_date={order_date}&delivery_date={delivery_date}&keyword={keyword}&batched={batched}&dealer={dealer}&from={from}&through={through}&sort_direction={sort_direction}');
let states = new LaravelApiModule('/order/api/states');
let users = new LaravelApiModule('/order/api/users');
let userList = new LaravelApiModule('/order/api/users?role={role}&keyword={keyword}&page={page}');
let userAddresses = new LaravelApiModule('/order/api/user-addresses');
let userOrders = new LaravelApiModule('/order/api/user-orders');
let zipCodes = new LaravelApiModule('/order/api/zip-codes', {idProperty: 'zip_code'}); // set API route and primary key
let zipCodeList = new LaravelApiModule('/order/api/zip-codes?keyword={keyword}&page={page}', {idProperty: 'zip_code'}); // set API route and primary key

let totals = new LaravelApiModule('/order/api/reports?start_date={start_date}&end_date={end_date}&batch_numbers={batch_numbers}');
let totalsByBatch = new LaravelApiModule('/order/api/reports/by-batch?start_date={start_date}&end_date={end_date}&batch_numbers={batch_numbers}', 'batch_number');
let totalsByCompany = new LaravelApiModule('/order/api/reports/by-company?start_date={start_date}&end_date={end_date}&batch_numbers={batch_numbers}', 'company_id');


orderList.getters.loaded = () => false;
userList.getters.loaded = () => false;
zipCodeList.getters.loaded = () => false;

export default new Vuex.Store({
    modules: {
        companies,
        companyMembers,
        dealerZones,
        holidays,
        orders,
        orderList,
        states,
        totals,
        totalsByBatch,
        totalsByCompany,
        users,
        userAddresses,
        userList,
        userOrders,
        zipCodes,
        zipCodeList,
    },
});